import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {ChangeLanguageModule} from '../shared/change-language/change-language.module';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {NgxPaginationModule} from 'ngx-pagination';
import {LayoutModule} from '../layout/layout.module';
import {MstUnitService} from '../configuration/mst-unit/mst-unit.service';
import {AutoCompleteModule, DialogModule, MultiSelectModule} from 'primeng/primeng';
import {MstCabinService} from '../configuration/mst-cabin/mst-cabin.service';
import {MstStaffService} from '../configuration/mst-staff/mst-staff.service';
import {MourturyComponent} from './mourtury.component';
import {routing} from './mourtury.routing';
import {DataTableModule} from 'primeng/primeng';

@NgModule({
    imports: [
        CommonModule,
        routing,
        FormsModule,
        HttpModule,
        ReactiveFormsModule, SharedTranslationModule, ChangeLanguageModule,
        NgxPaginationModule, LayoutModule,
        AutoCompleteModule, MultiSelectModule, DialogModule, DataTableModule
    ],
    declarations: [MourturyComponent],
    providers: [MstUnitService, MstCabinService, MstStaffService]
})
export class MourturyModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/mourtury/mourtury.module.ts